import { Button, Stack } from '@mui/material';
import { useForm } from 'react-hook-form';
import * as Yup from 'yup';
import { ApiResultModal } from '../../../../components/modal/ApiResultHandler';
import { FormModal } from '../../../../components/modal/FormModal';
import { useModalToggle } from '../../../../components/modal/Modal';
import { useAuthAxios } from '../../../../hooks/useAuthAxios';
import { useYupValidationResolver } from '../../../../hooks/useYupValidationResolver';
import { OUTDOOR_GYM_EQUIPMENT_ID } from '../../../../utils/enum';
import { CreateSportingForm } from '../../CategoryPage/Common/CreateCategoryForm';
import {
  sportingDefaultValue,
  sportingSchema,
} from '../../CategoryPage/Common/DefaultValuesAndSchema';

export default function AddOutdoorEquipmentButton() {
  const { on, open, close } = useModalToggle();
  const onCloseModal = () => {
    close();
    form.reset();
  };

  const resolver = useYupValidationResolver(
    Yup.object().shape({
      ...sportingSchema,
    }),
  );

  const form = useForm<any>({
    mode: 'onTouched',
    resolver,
    defaultValues: {
      ...sportingDefaultValue,
    },
    shouldUnregister: false,
  });
  const [postSportingResult, postSporting] = useAuthAxios({
    method: 'POST',
    url: '/api/v1/subcategory',
  });

  const onSubmit = form.handleSubmit(function (values) {
    const payload = {
      title: values.title,
      subCategoryType: values.subCategoryType,
      notes: values.notes,
      categoryId: OUTDOOR_GYM_EQUIPMENT_ID,
    };
    postSporting({ data: payload });
  });

  return (
    <Stack>
      <Button
        onClick={open}
        variant="text"
        sx={{ fontSize: '14px', fontWeight: 500 }}
      >
        운동기구 추가
      </Button>
      <FormModal
        on={on}
        onClose={onCloseModal}
        title="운동기구 추가"
        children={<CreateSportingForm form={form} />}
        onConfirm={onSubmit}
      />
      <ApiResultModal
        apiResult={postSportingResult}
        successTitle="등록됐습니다."
        successContent="해당 운동기구가 추가되었습니다."
        successCode={201}
        onSuccessClose={() => {
          onCloseModal();
        }}
        failTitle="관리자에게 문의해주세요."
        ErrorCodeTable={{
          PAYLOAD_INVALID: { title: '입력값을 확인해주세요' },
          DUPLICATE_INSPECTION_RESULT: {
            title: '이미 존재하는 점검상태입니다.',
          },
          DUPLICATE_CATEGORY: { title: '이미 존재하는 유형입니다.' },
          DUPLICATE_SUB_CATEGORY: { title: '이미 존재하는 운동기구입니다.' },
          DUPLICATE_DEPARTMENT: { title: '이미 존재하는 부서입니다.' },
        }}
      />
    </Stack>
  );
}
